import { ZAttrMeta } from "src/business/attribute";
import {
  AttrVisitor,
  AttrVisitorCtx,
} from "src/business/attribute/AttrVisitor";
import { walkAttr } from "src/business/attribute/AttrVisitor/walkAttr";

export type AttrRow = {
  key: string;
  ownerKeys: string[]; // от ближайшего к верхнему
  isLeaf: boolean;
  attr: ZAttrMeta;
};

export const buildRows = (attrList: ZAttrMeta[]): AttrRow[] => {
  const list: AttrRow[] = [];
  const uidToKeyMap: Record<string, string> = {};
  const visitor: AttrVisitor = {
    onEach(attr, ctx) {
      const ownerKeys =
        ctx.owners?.map(({ uid }) => uidToKeyMap[uid] ?? "") ?? [];
      const key = makeKey(attr, ownerKeys);
      uidToKeyMap[attr.uid] = key;
      list.push({ key, ownerKeys, attr, isLeaf: true });
    },
    onEnter() {
      const last = list[list.length - 1];
      if (last) last.isLeaf = false;
    },
  };
  attrList.forEach((attr) => {
    const ctx: AttrVisitorCtx = {};
    walkAttr(attr, visitor, ctx);
  });
  return list;
};

const makeKey = (attr: ZAttrMeta, ownerKeys: string[]): string =>
  [attr.uid, ...ownerKeys].join("::");
